import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { useToastMessage } from "@poseidon/ui/app/toasts/useToastMessage";
import config from "@poseidon/utils/config";
import { updateEntity } from "@poseidon/firebase";
import { db } from "@poseidon/firebase/firebase";
import { useAuth } from "@poseidon/ui/components/AuthContext";
import { doc } from "firebase/firestore";
import { mapBoatToBoatUpdateRequest } from "./mapBoat";
import { Formik } from "formik";
import Form from "@poseidon/ui/components/form/FullWidthForm";
import { Button, Grid, Stack, Typography } from "@mui/material";
import {
  FormikDisabler,
  Panel,
  usePermissions,
} from "@poseidon/ui/components";

export function BoatFormWrapper({ boat, title, children, readonly, asDealer }) {
  const { canWrite } = usePermissions();
  const { setError } = useErrorMessage();
  const { setToast } = useToastMessage();
  const { SaltCollection } = config;
  const { user } = useAuth();

  async function onSubmitHandler(values) {
    try {
      await updateEntity(
        SaltCollection.Boat,
        boat.id,
        {
          ...mapBoatToBoatUpdateRequest(values, asDealer),
          // Lets the backend tell dealer edits from staff ones (e.g. for the
          // "dealer completed boat details" Teams notification).
          lastUpdatedBy: doc(db, asDealer ? "dealers" : "admins", user.uid),
        }
      );
      setToast("Successfully updated Boat");
    } catch (error) {
      setError(error.message);
    }
  }

  return (
    <Formik initialValues={boat} onSubmit={onSubmitHandler} enableReinitialize>
      {({ dirty, resetForm }) => (
        <Form>
          <FormikDisabler disabled={readonly || !canWrite} />
          <Stack spacing={5} sx={{ px: 5, mb: 5 }}>
            <Grid container>
              <Grid item xs={12} sm={8}>
                <Typography variant="h5">{title ?? "Boat Record"}</Typography>
              </Grid>
              <Grid item xs={12} sm={4} sx={{ textAlign: "right" }}>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  margin="none"
                  disabled={!dirty}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
            {children}
            {dirty && (
              <Panel title="Unsaved changes">
                <Grid item xs={12} sm={6} sx={{ mt: 2 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    margin="none"
                  >
                    Save
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => resetForm()}
                    margin="none"
                    sx={{ ml: 1 }}
                  >
                    Discard Changes
                  </Button>
                </Grid>
              </Panel>
            )}
          </Stack>
        </Form>
      )}
    </Formik>
  );
}
